// extracted by mini-css-extract-plugin
module.exports = {"container":"Navbar_container__VeJ04","navbar":"Navbar_navbar__1ZafV","logo":"Navbar_logo__19oGG","user":"Navbar_user__2H-Q_"};